import React from 'react';
import PropTypes from 'prop-types';
import { Route, Routes } from 'react-router-dom';

import HomePage from '../../pages/Home';
import CartPage from '../../pages/Cart';
import CheckoutPage from '../../pages/Checkout';
import GiftCardDetailDisplay from '../GiftCardDetailDisplay';
import CheckoutSuccess from '../CheckoutSuccess';
import CheckoutFailure from '../CheckoutFailure';

const AppRouter = (props) => {
	const { siteId } = props;

	return (
		<Routes>
			<Route path='/' element={<HomePage siteId={siteId} />} />
			<Route path='/cart' element={<CartPage />} />
			<Route path='/checkout' element={<CheckoutPage />} />
			<Route path='/giftCard/:id' element={<GiftCardDetailDisplay />} />
			<Route path='/checkout/complete' element={<CheckoutSuccess />} />
			<Route path='/checkout/error' element={<CheckoutFailure />} />
		</Routes>
	);
};

AppRouter.propTypes = {
	resetTokenValue: PropTypes.func,
	setTokenValue: PropTypes.func,
	siteId: PropTypes.number
};

export default AppRouter;
